import { useState, Fragment } from 'react';
import CreatableSelect from 'react-select/creatable';

function MultiInputText({ value, setValue, heading, setRemovedValues }) {
  const [inputValue, setInputValue] = useState('');

  function handleChange(value, actionMeta) {
    if (actionMeta?.action === 'remove-value') {
      setRemovedValues(actionMeta?.removedValue ?? []);
    }

    setValue(value);
  }

  function handleInputChange(inputValue) {
    setInputValue(inputValue);
  }

  function handleKeyDown(event) {
    if (!inputValue) return;

    if (['Enter', 'Tab'].includes(event.key)) {
      setInputValue('');
      setValue([...value, createOption(inputValue)]);

      event.preventDefault();
    }
  }

  return (
    <Fragment>
      <label>{heading}</label>
      <CreatableSelect
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: '#e9baf0',
            'box-shadow': '0 0.8rem 1.2rem rgba(20, 102, 204, 0.14)',
          }),
          multiValue: (styles) => {
            return {
              ...styles,
              backgroundColor: '#fadbff',
            };
          },
        }}
        components={components}
        inputValue={inputValue}
        isClearable
        isMulti
        menuIsOpen={false}
        onChange={handleChange}
        onInputChange={handleInputChange}
        onKeyDown={handleKeyDown}
        placeholder={`${heading}...`}
        value={value}
      />
    </Fragment>
  );
}

const components = {
  DropdownIndicator: null,
};

const createOption = (label) => ({
  label,
  value: label,
});

MultiInputText.defaultProps = {
  value: [],
  heading: 'Add specializations',
  setValue: () => {},
  setRemovedValues: () => {},
};

export default MultiInputText;
